import { Component, contentChild, forwardRef, type TemplateRef, input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ControlErrorComponent } from '@pct-ng/form';
import { FileUploadComponent } from '@pct-ng/feature-file-upload-native';
import { MaterialFileDropZoneContentComponent } from './material-file-drop-zone-content.component';
import { MaterialFileListComponent } from './material-file-list.component';
import { NgTemplateOutlet } from '@angular/common';
import { I18nProviderInjectionToken } from './i18n/scope';
import { provideI18nScope } from '@pct-ng/transloco';
import { AbstractMaterialFileUploadComponent } from './abstract-material-file-upload.component';

@Component({
  selector: 'pct-feature-file-upload-material-component',
  imports: [
    FileUploadComponent,
    MaterialFileDropZoneContentComponent,
    MaterialFileListComponent,
    NgTemplateOutlet,
    ControlErrorComponent,
    MaterialFileListComponent,
  ],
  templateUrl: './material-file-upload.component.html',
  providers: [
    provideI18nScope(I18nProviderInjectionToken),
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MaterialFileUploadComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MaterialFileUploadComponent),
      multi: true,
    },
  ],
})
export class MaterialFileUploadComponent<T> extends AbstractMaterialFileUploadComponent<T> {
  protected readonly fileListContent = contentChild<TemplateRef<unknown>>('fileListContentTpl');
  hasErrorFromOutside = input<boolean>(false);
  protected readonly Validators = Validators;
}
